/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_csv_import } from '../models/Body_csv_import';
import type { CsvIgnoreEntry } from '../models/CsvIgnoreEntry';
import type { CsvImportResponse } from '../models/CsvImportResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CsvService {
    /**
     * CSVインポート用の無視リストを取得する
     * @returns CsvIgnoreEntry Successful Response
     * @throws ApiError
     */
    public static csvIgnoreList(): CancelablePromise<Array<CsvIgnoreEntry>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/csv/ignore-list',
        });
    }
    /**
     * CSVを選択中のExcelに取り込む
     * CSVファイルを読み込み、選択中のExcelファイルへ書き込む処理を行う（雛形）。
     * 実際のExcel書き込みは CsvImportService 内の TODO 部分で実装してください。
     * @param formData
     * @returns CsvImportResponse Successful Response
     * @throws ApiError
     */
    public static csvImport(
        formData?: Body_csv_import,
    ): CancelablePromise<CsvImportResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/csv/import',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
